import React from 'react';
import { Box, Grid } from '@mui/material';
import { TrendAnalysis } from './components/TrendAnalysis';
import { GoalProgress } from './components/GoalProgress';
import { RiskAnalysis } from './components/RiskAnalysis';
import { PredictiveIndicators } from './components/PredictiveIndicators';
import { InterventionEffectiveness } from './components/InterventionEffectiveness';

export const DataInsights: React.FC = () => {
  return (
    <Box 
      sx={{ 
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
        p: 2,
        height: '100%'
      }}
    >
      <Box 
        component="div" 
        sx={{ 
          typography: 'h4',
          fontWeight: 500
        }}
      >
        Data-Driven Insights
      </Box>

      <Box sx={{ flexGrow: 1, minHeight: 0, overflow: 'auto' }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <GoalProgress />
          </Grid>

          <Grid item xs={12} md={6}>
            <TrendAnalysis />
          </Grid>

          <Grid item xs={12} md={6}>
            <InterventionEffectiveness />
          </Grid>

          <Grid item xs={12}>
            <RiskAnalysis />
          </Grid>

          <Grid item xs={12}>
            <PredictiveIndicators />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};